import React from "react";
import "./Contact.css";
import Fast from "./fast.png";
import Responsive from "./responsive.png";
import Dynamic from "./dynamic.png";
import Email from "./email.png";
import Github from "./github.png";

function Contact() {
  return (
    <div className="main">
      <h2>Specialty</h2>
      <section className="focus">
        <div className="item">
          <img src={Fast} alt="fast" />
          <h3>Fast</h3>
          <p>Fast load times and lag free interaction, my highest priority.</p>
        </div>
        <div className="item">
          <img src={Responsive} alt="responsive" />
          <h3>Responsive</h3>
          <p>My layouts will work on any device, big or small.</p>
        </div>
        <div className="item">
          <img src={Dynamic} alt="dynamic" />
          <h3>Dynamic</h3>
          <p>
            Websites don't have to be static, I love making pages come to life.
          </p>
        </div>
      </section>
      <p>Lets work together!</p>
      <section className="linked">
        <a href="mailto:tanveersayem@gmail.com">
          <img className="contact-email" src={Email} alt="email" />
        </a>
        <a href="https://github.com/w3tsa" target="_blank noopener noreferrer">
          <img className="contact-git" src={Github} alt="github" />
        </a>
      </section>
    </div>
  );
}

export default Contact;
